module.exports = __webpack_public_path__ + "img/icn_circle_planning_table-dark.f0628396.svg";